import React, { useEffect, useState, useRef, useCallback } from "react";
import style from "../../css/admin/Totaluser.module.css";
import axios from "axios";
import { API_BASE_URL } from "../ApiConfig";
import { getSecureToken } from "../ApisService/apiService";

const TotalUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  useEffect(() => {
    fetchUsers();
  }, [page, statusFilter]);

  const fetchUsers = async () => {
    const { secrettoken, ts } = await getSecureToken();
    try {

      const response = await axios.get(`${API_BASE_URL}Total_users.php`, {
        params: {
          page,
          limit: 10,
          status: statusFilter,
        },
        headers: {
          'X-TOKEN': secrettoken,
          'X-TIMESTAMP': ts,
        },
        withCredentials: true,
      });

      const result = response.data;

      if (result.status === "success") {
        setUsers((prevUsers) =>
          page === 1 ? result.data : [...prevUsers, ...result.data]
        );
        setHasMore(result.data.length === 10);
      } else {
        console.warn("Unexpected response status:", result.status);
      }
    } catch (error) {
      console.error("Error fetching users:", error?.response?.data || error.message);
    }
  };


  const lastUserRef = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [hasMore]
  );

  const filteredUsers = users.filter((user) =>
    [user.full_name, user.email, user.mobile_number].some((field) =>
      field.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div className={style.container}>
      <h2 className={style.heading}>Total Users</h2>

      <div className={style.filterContainer}>
        <input
          type="text"
          placeholder="Search users..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className={style.searchInput}
        />

        <select
          value={statusFilter}
          onChange={(e) => {
            setStatusFilter(e.target.value);
            setPage(1);
          }}
          className={style.filterDropdown}
        >
          <option value="all">All Users</option>
          <option value="active">Active Users</option>
          <option value="inactive">Inactive Users</option>
        </select>
      </div>

      <div className={style.tableContainer}>
        <table className={style.userTable}>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Mobile Number</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user, index) => (
                <tr key={user.id} ref={index === filteredUsers.length - 1 ? lastUserRef : null}>
                  <td>{index + 1}</td>
                  <td>{user.full_name}</td>
                  <td>{user.mobile_number}</td>
                  <td>{user.email}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className={style.noData}>No users found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TotalUsers;
